import React from 'react'
import { BsArrowRightShort } from "react-icons/bs";

const CustomViewButton = ({ onClick, label = "View"})=>{
    return (
        <button
          className="btn btn-sm px-3 btn-primary"
          onClick={onClick}
        >
          <BsArrowRightShort className="me-1" /> {label}
        </button>
      );
}

export default CustomViewButton;